import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { DialogImage, DialogService, ImageDialogComponent, ImageDialogData } from '@mitsubishi/ui/dialog';

import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'apm-image-type',
  templateUrl: './image-type.component.html',
  styleUrls: ['./image-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class ImageTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
  dialogService = inject(DialogService);

  isGallery = false;
  isUrl = false;
  ngOnInit() {
    this.isGallery = this.field.parent?.wrappers?.some(wrapper => wrapper === 'gallery') || false;
    this.isUrl = this.checkValueIsURL();
  }

  checkValueIsURL() {
    try {
      new URL(this.field.defaultValue);
      return true;
    } catch (e) {
      return false;
    }
  }

  toggleFullScreen() {
    const images: DialogImage[] = [
      {
        url: this.isUrl ? this.field.defaultValue : undefined,
        base64: !this.isUrl ? 'data:image/png;base64,' + this.field.defaultValue : undefined,
      },
    ];

    if (this.field.props?.compareValue) {
      images.push({
        url: this.isUrl ? this.field.props?.compareValue : undefined,
        base64: !this.isUrl ? 'data:image/png;base64,' + this.field.props?.compareValue : undefined,
      });
    }

    const data: ImageDialogData = {
      title: this.field.props?.label,
      images: images,
    };
    this.dialogService.openDialogScroll(ImageDialogComponent, 'xl', data);
  }
}
